import React from 'react';
import '../styles/SalesSocialProofToast.css';

function ToastTicketIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4.5 8.5c0-1 .8-1.8 1.8-1.8h11.4c1 0 1.8.8 1.8 1.8v.6a1.1 1.1 0 110 2.2 1.1 1.1 0 010 2.2 1.1 1.1 0 11-1.1 1.1H6.3A1.1 1.1 0 015.2 15.5a1.1 1.1 0 010-2.2 1.1 1.1 0 010-2.2 1.1 1.1 0 011.1-1.1h.2v-.5z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinejoin="round"
      />
      <path
        d="M9.2 10.6l1.8 1.8 3.8-3.8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SalesSocialProofToast({ message, onDismiss }) {
  if (!message) return null;

  return (
    <div className="sales-social-proof-toast" role="status" aria-live="polite">
      <div className="sales-social-proof-toast__accent" aria-hidden="true" />
      <div className="sales-social-proof-toast__iconWrap" aria-hidden="true">
        <div className="sales-social-proof-toast__icon">
          <ToastTicketIcon />
        </div>
      </div>
      <div className="sales-social-proof-toast__content">
        <span className="sales-social-proof-toast__eyebrow">Rezervare recentă</span>
        <p className="sales-social-proof-toast__text">{message}</p>
      </div>
      <button
        type="button"
        className="sales-social-proof-toast__close"
        onClick={onDismiss}
        aria-label="Închide"
      >
        ×
      </button>
    </div>
  );
}
